import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=586b3d6e"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports